<template>
  <div class="right">

    <rightTop @data="getCreditDataFn"></rightTop>

    <div class="rightCenter">
      <div class="centerTit">资产负债表</div>
      <div style="width:80%;position: relative;">
        <div @click="downloadFn(0)" style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:21px;margin-left:20px;">
          <img src="@/assets/img/Excel.png" alt style="display: inline-block;height: 18px;width:18px;float:left;" />
          <span style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;">下载数据到Excel</span>
        </div>
        <div style="width:165px;float:right;position: relative;">
          <el-select v-model="searchData1.value" size="small" placeholder="报表范围选择">
            <el-option
              v-for="item in searchData1.select"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <div @click="SelectTimeFn1" style="position: absolute;top: 0;left:0;width:100%;height: 100%;cursor: pointer;"></div>
        </div>
        <el-card class="box-card SelectAlert" style="position: absolute;top:54px;right:19%;width:335px;height:302px;z-index: 1000000;display: none;">
          <h5 style="font-size:14px;font-family:Microsoft YaHei;font-weight:bold;color:#000;line-height:1;margin-bottom:23px;">日期范围</h5>
          <el-radio-group v-model="changeTime.radio">
            <el-radio :label="2" style="width:40px;color:#000000;">近两年</el-radio>
            <el-radio :label="3" style="width:40px;color:#000000;">近三年</el-radio>
            <el-radio :label="5" style="width:40px;color:#000000;">近五年</el-radio>
            <el-radio :label="10" style="width:40px;color:#000000;">近十年</el-radio>
            <el-radio :label="-1" style="width:80px;display: inline-block;margin-top:30px;margin-right:0;color:#000000;">自定义</el-radio>
            <el-input @focus="startTimeFn" @blur="startTimeTestFn(1)" v-model="changeTime.startTime" placeholder="2010-11" size="mini" style="display: inline-block;width:90px;"></el-input>
            <span style="display: inline-block;width:8px;height: 1px;position: relative;top: -4px;background:#000;margin:0 10px;"></span>
            <el-input @focus="startTimeFn" @blur="startTimeTestFn(2)" v-model="changeTime.endTime" placeholder="2010-11" size="mini" style="display: inline-block;width:90px;"></el-input>
          </el-radio-group>
          <div style="width:98%;height:1px;background:#DFDFDF;margin-top:21px;margin-bottom:20px;"></div>
          <h5 style="font-size:14px;font-family:Microsoft YaHei;font-weight:bold;color:#000;line-height:1;">报告期</h5>
          <el-checkbox-group v-model="changeTime.checkedCities" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="city in changeTime.cities" :label="city" :key="city" style="width:45px;color:#000000;">{{city}}</el-checkbox>
          </el-checkbox-group>
          <div style="height: 40px;line-height:1;text-align: center;">
            <el-button @click="changeTimeTrue" type="primary" size="mini">确定</el-button>
            <el-button @click="changeTimeClose" type="info" size="mini">关闭</el-button>
          </div>
        </el-card>
      </div>
    </div>
    <div class="rightBottom">
      <!-- 第一套 :show-header="false" -->
      <el-table 
        v-loading="loading"
        :data="tableData1" 
        ref="tableRef"
        border 
        size="mini" 
        :header-cell-style="headerCellStyleFn"
        :cell-style="cellStyle"
        style="width: 100%;"
        height="60vh">
        <!-- :header-cell-style="{'font-size':'12px!important','color': '#333333','font-family':'Microsoft YaHei','background':'#F7F7F7','font-weight':'bold'}" -->
        <el-table-column
          v-for="(item,index) in tableData1[0]"
          :prop="index + ''"
          :width="index == 0 ? '238' : 138 "
          :fixed="(index == 0) ? true : false "
          :label="item"
          :key="index">
          <!-- item[index + ''] -->
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
import $ from 'jquery';
export default {
  data() {
    return {
      tableData1:[],
      loading: false,
      //选择数据
      searchData1:{
        select:[],//下拉框选项数据
        value: '',
      },
      companyList:[],
      paramsData:{},//URL参数集合
      changeTime:{//报表范围选项数据
        radio:'',
        startTime:'',
        endTime:'',
        checkedCities: ['一季度', '中报', '三季度', '年报'],
        cities: ['一季度', '中报', '三季度', '年报'],
      },
      styles:[]//获取表格加粗集合
    };
  },
  watch: {
    changeTime:{
      handler(val, oldVal){
        // console.log(val.radio, oldVal.radio,'val1');
        if(val.radio != -1){
          this.changeTime.endTime = '';
          this.changeTime.startTime = '';
        }
      },
      deep:true //true 深度监听
    }
  },
  components:{
    rightTop
  },
  methods: {
    //收藏组件方法部分
    getCreditDataFn(data){
      console.log(data,'mytest')
      this.paramsData.stockCode = data[0].companyStockCode;
      this.paramsData.enterpriseCode = data[0].enterpriseCode;
      this.action();//获取表格数据
      
    },
    //筛选条件确定按钮
    changeTimeTrue(){
      let startDate = '';
      let endDate = '';
      let reportDate = '';
      
      if(this.changeTime.radio == -1){//开始结束时间写了就要写完整
        if(this.changeTime.startTime == ''){
          this.$message.error('请填写开始时间！');
          return;
        }
        if(this.changeTime.endTime == ''){
          this.$message.error('请填写结束时间！');
          return;
        }
        startDate = this.changeTime.startTime;
        endDate = this.changeTime.endTime;
      }else{
        if(this.changeTime.radio == ''){
          startDate = '';
          endDate = '';
        }else{
          startDate = magic.getSomeYearsBefor(this.changeTime.radio).substring(0,7);
          endDate = magic.getSomeYearsBefor(0).substring(0,7);
        }
      }
      if(this.changeTime.checkedCities.length == 0){//报告期要至少选一个
        this.$message.error('请选择报告期！');
        return;
      }
      let tmpArr = this.changeTime.checkedCities;
      for(var i=0;i<tmpArr.length;i++){
        
        if(tmpArr[i] == '一季度'){
          tmpArr.length-1 == i ? reportDate += '03' : reportDate += '03,';
        }
        if(tmpArr[i] == '中报'){
          tmpArr.length-1 == i ? reportDate += '06' : reportDate += '06,';
        }
        if(tmpArr[i] == '三季度'){
          tmpArr.length-1 == i ? reportDate += '09' : reportDate += '09,';
        }
        if(tmpArr[i] == '年报'){
          tmpArr.length-1 == i ? reportDate += '12' : reportDate += '12,';
        }
      }
      console.log(startDate,endDate,reportDate);

      setTimeout(()=>{
        this.fetchTable1(this.paramsData.stockCode, this.paramsData.enterpriseCode, startDate, endDate, reportDate);//按产品
        $('.el-table thead tr th').css({'background':'#F7F7F7','color':'#333','font-size':'12px','font-weight':'bold'});
        $('.SelectAlert').css('display','none');
      },900)
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
          LogCollection.send(9);
      }catch(e){}
    },
    //日期正则校验
    isDate(dateString) {
      if(dateString.trim()=="")return false;
      //年月日正则表达式
      var r=dateString.match(/^(\d{1,4})(-)(\d{1,2})$/); 
      if(r==null){
        return false;
      }
      return true;
    },
    //筛选条件关闭按钮
    changeTimeClose(){
      $('.SelectAlert').css('display','none');
    },
    //日期范围里时间段input函数
    startTimeFn(){
      this.changeTime.radio = -1;
    },
    // 日期输入框正则校验
    startTimeTestFn(num){
      let bool = '';
      if(num == 1){
        bool = this.isDate(this.changeTime.startTime);
      }
      if(num == 2){
        bool = this.isDate(this.changeTime.endTime);
      }
      if(!bool){
        this.$message.error('请输入正确的时间格式！');
        num == 1 ? this.changeTime.startTime = '' : this.changeTime.endTime = '';
      }
    },
    //多选框函数
    handleCheckedCitiesChange(value){
      console.log(value,'value')
    },
    headerCellStyleFn({ row, column, rowIndex, columnIndex }){
      console.log(rowIndex,'rowIndex')
      return 'font-size:12px;color: #333333;font-family:Microsoft YaHei;background:#F7F7F7;font-weight:bold';
    },
    cellStyle(row, column, rowIndex, columnIndex){
      //styles
      let _this = this;
      if(row.columnIndex == 0){
        if(_this.styles.length > 0){
          for(let i=0;i<_this.styles.length;i++){
            if(row.row[0] == _this.styles[i]){
              return 'color: #DFECF7;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;'
            }
          }
        }
        if(row.rowIndex == 0){
          return 'color: #DFECF7;font-family:Microsoft YaHei;background:#F7F7F7;display:none;font-weight:bold;'
        }
        return 'color: #DFECF7;font-family:Microsoft YaHei;background:#F7F7F7;font-weight:bold;'
      }
      if(row.rowIndex == 0){
        return 'color: #DFECF7;font-family:Microsoft YaHei;background:#F7F7F7;display:none;font-weight:bold;'
      }
    },
    //下载函数
    downloadFn(incomeType){
      let _this = this;
      //收入类型分类 0:按产品 1:按行业 2:按地域
      let reportDate = '';
      if(incomeType == 0){
        reportDate = this.searchData1.value;
      }else if(incomeType == 1){
        reportDate = this.searchData2.value;
      }else if(incomeType == 2){
        reportDate = this.searchData3.value;
      }
      this.download(window.baseUrl + '/financialData/downAssetDebtData?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode + '&incomeType=' + incomeType + '&reportDate=' + reportDate);
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏
          //3：下载
          //4：分享
          //5：购买
          //6：登录
          //7：注册
          //9：搜索
          //10：复制
          //11：点赞
          //12：评论
          LogCollection.send(3);
      }catch(e){}
    },
    download(url) {
      let a = document.createElement('a');
      a.href = url;
      let _id = Math.random()+Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    //第一个下拉框
    SelectTimeFn1(val){
      let state = $('.SelectAlert').css('display');
      if(state == 'block'){
        $('.SelectAlert').css('display','none');
      }else{
        $('.SelectAlert').css('display','block');
      }
    },
    action(){
      setTimeout(()=>{
        this.fetchTable1(this.paramsData.stockCode,this.paramsData.enterpriseCode,'','','');//按产品
        $('.el-table thead tr th').css({'background':'#F7F7F7','color':'#333','font-size':'12px','font-weight':'bold'});
      },900)
    },
    fetchTable1(stockCode,enterpriseCode,startDate,endDate,reportDate){
      this.loading = true;
      let _this = this;
      let params = {}
      if(startDate == '' && endDate == '' && reportDate ==''){
        params = { 
          "stockCode":stockCode,  
          "enterpriseCode":enterpriseCode,  
        }
      }else{
        params = { 
          "stockCode":stockCode,  
          "enterpriseCode":enterpriseCode,  
          "startDate":startDate,
          "endDate":endDate,
          "reportDate":reportDate
        }
      }
      
      api.liabilitiesOne(params).then(res=>{
          let data = res.data;
          let tmpData = [];
          for(let i=0;i<data.length;i++){
            let tmpObj = {}
            for(let item in data[i]){
              if(item == 0){
                tmpObj[item] = data[i][item];
              }else if(item >1){
                if(data[i][item] != 'parentName'){
                  let _index = Number(item)-1 + '';
                  tmpObj[_index] = data[i][item];
                }
              }else if(item == 1){
                if(data[i][item] == ''){
                  _this.styles.push(data[i][0]);
                }
              }
            }
            tmpData.push(tmpObj);
          }
          _this.tableData1 = tmpData;
          _this.$nextTick(()=>{
            _this.$refs.tableRef.doLayout(); 
          })
          setTimeout(()=>{
              _this.loading = false;//取消loading
          },1000);
      })   
    }
  },
  mounted() {
    
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    background: #ffffff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    overflow:hidden;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    background: #fff;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
      overflow:hidden;
    }
  }
}
/deep/ .el-table__body-wrapper,/deep/ .el-table__header-wrapper{
   background: #052B4F !important;
}
.mailTable, .mailTable tr, .mailTable tr td{ border:1px solid #DFDFDF;}
.mailTable{ font-size: 14px; color: #4B4B4B; width:100%;font-family:Microsoft YaHei;}
.mailTable tr td{ border:1px solid #DFDFDF; width: 80%; height: 35px; line-height: 35px; box-sizing: border-box; padding: 0 10px; }
.column { background-color: #F7F7F7; color: #333333; font-size:14px;font-weight:bold;width:20%;}
.el-table thead{
  background-color: #F7F7F7!important; 
  color: #333333!important;
  font-size:14px!important;
  font-weight:bold!important;
}



</style>


// WEBPACK FOOTER //
// src/view/finance/liabilities.vue